/**
 * next-intl Link already prefixes the active locale.
 * If an incoming href is already locale-prefixed (e.g. "/ru/otel/..."),
 * passing it to the localized Link can result in a duplicated locale ("/ru/ru/otel/...").
 *
 * This helper removes one or more leading locale segments from an internal path.
 */
export function stripLeadingLocalePrefix(href, locale) {
  if (!href || typeof href !== "string") return href;
  if (!locale || typeof locale !== "string") return href;

  // Don't touch absolute URLs (http:, https:, mailto:, etc.) or protocol-relative URLs.
  if (/^[a-zA-Z][a-zA-Z\d+\-.]*:/.test(href) || href.startsWith("//")) {
    return href;
  }

  // Only normalize internal absolute paths.
  if (!href.startsWith("/")) return href;

  const normalizedLocale = locale.toLowerCase();
  const baseLocale = normalizedLocale.split("-")[0]; // e.g. "ru-RU" -> "ru"
  const localeAlternatives = Array.from(
    new Set([normalizedLocale, baseLocale].filter(Boolean)),
  );

  // Preserve query/hash while normalizing the path part.
  const [beforeHash, hash = ""] = href.split("#", 2);
  const [pathPart, queryPart = ""] = beforeHash.split("?", 2);

  const localeGroup = localeAlternatives.map(escapeRegExp).join("|");
  const strippedPath = pathPart.replace(
    new RegExp(`^(?:/(?:${localeGroup}))+(?=/|$)`, "i"),
    "",
  );

  const finalPath = strippedPath === "" ? "/" : strippedPath;
  const withQuery = queryPart ? `${finalPath}?${queryPart}` : finalPath;
  const withHash = hash ? `${withQuery}#${hash}` : withQuery;
  return withHash;
}

function escapeRegExp(value) {
  return String(value).replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
}

